import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ultricies tellus non sagittis elementum. Curabitur et ipsum velit. Nam varius elit non dui fringilla, et faucibus elit tempus. Cras vel leo velit. Vestibulum finibus, felis a ultricies tempor, odio urna imperdiet urna, id consectetur est elit eu massa. Fusce vestibulum sapien id neque egestas consectetur. 
      </p>
    </section>
  )
}

export default About
